export type ComposeFunction<Type> = (a: Type[]) => Type;
export type MapFunction<Type> = (a: Type) => Type;

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function compose(...fns: ComposeFunction<any>[]): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (x: any) => {
    return fns.reduceRight((v, f) => {
      return f(v);
    }, x);
  };
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function composePipe(...fns: ComposeFunction<any>[]): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (x: any) => fns.reduce((v, f) => f(v), x);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function map(fn: MapFunction<any>): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return (mappable: any) => mappable.map(fn);
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function asyncMap(fn: MapFunction<any>): any {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  return async (mappable: any) => await Promise.all(mappable.map(fn));
}
